import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card'
import { requestMobile } from '@/lib/request'
import { toast } from 'sonner'
import { Smartphone } from 'lucide-react'

export default function MobileLogin() {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault()

    if (!username || !password) {
      toast.error('请输入用户名和密码')
      return
    }

    setLoading(true)
    try {
      // skipAuth: true 跳过 Authorization 头
      const resp = await requestMobile('/common/login', { username, password }, true)
      if (resp && !resp.code) {
        // 原项目直接存储 resp.data 作为 token
        localStorage.setItem('token', resp.data)
        // 使用 React Router 导航，保持在 PWA 容器内
        navigate('/mobile/task', { replace: true })
      }
    } catch (error) {
      toast.error('登录失败，请重试')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-background via-background to-accent/20 p-4">
      <Card className="w-full max-w-sm shadow-2xl border-border/50 backdrop-blur-sm bg-card/95">
        <CardHeader className="space-y-2 text-center pb-6">
          <div className="mx-auto w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-4">
            <Smartphone className="w-8 h-8 text-primary" />
          </div>
          <CardTitle className="text-3xl font-bold bg-gradient-to-r from-primary to-blue-600 bg-clip-text text-transparent">
            移动端登录
          </CardTitle>
          <CardDescription className="text-base">
            输入您的凭据以访问移动端
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleLogin} className="space-y-5">
            <div className="space-y-2">
              <Label htmlFor="mobile-username" className="text-sm font-medium">
                用户名
              </Label>
              <Input
                id="mobile-username"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="请输入用户名"
                disabled={loading}
                className="h-11 bg-background/50"
                autoComplete="username"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="mobile-password" className="text-sm font-medium">
                密码
              </Label>
              <Input
                id="mobile-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="请输入密码"
                disabled={loading}
                className="h-11 bg-background/50"
                autoComplete="current-password"
              />
            </div>
            <Button
              type="submit"
              className="w-full h-11 text-base font-medium shadow-lg shadow-primary/20 hover:shadow-xl hover:shadow-primary/30 transition-all"
              disabled={loading}
            >
              {loading ? (
                <>
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2" />
                  登录中...
                </>
              ) : (
                <>
                  <Smartphone className="mr-2 h-4 w-4" />
                  登录
                </>
              )}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  )
}
